import { Injectable, inject } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { SsoUserCreationRequest } from '../interfaces/sso-user-creation-request';
import { SsoUserDetailsDto } from '../interfaces/sso-user-details-dto';
import { envToken } from '../tokens/env-token';

@Injectable({
    providedIn: 'root'
})
export class UniversalIdCreateService {
    private http = inject(HttpClient);
    private env = inject(envToken);

    baseUrl = '';

    constructor() {
        this.baseUrl = this.env.apiUrl + '/api/v1/enterprise-user';
    }

    createUniversalId(ssoUserCreationRequest: Partial<SsoUserCreationRequest>): Observable<SsoUserDetailsDto> {
        ssoUserCreationRequest.username = ssoUserCreationRequest.username?.trim();
        return this.http.post<SsoUserDetailsDto>(`${this.baseUrl}`, ssoUserCreationRequest);
    }
}
